"use client";
import React, { useEffect, useRef } from "react";
import styles from "./home.module.css";
import AnimatedBackground from "../../components/animatedBackground";
import ProjectCard01 from "../../components/projectCard01";
import NameSVG from "../../images/svg/NameSVG";
import ContactModal from "../../components/contactModal";
import Timeline from "../../components/timeline/timeline";
import TechnicalSkills from "../../components/technicalSkills/TechnicalSkills";
const Home = () => {
  const jobTitleRef = useRef(null);
  const jobTitleRef2 = useRef(null);
  const getRandomLetter = () => {
    return String.fromCharCode(Math.floor(Math.random() * (128 - 57)) + 57);
  };
  // a is prev , b is new
  const convertOneWordToNext = (a, b, idx, timer) => {
    if (a === b) return [true, b];
    let ans = a;
    if (a.length > b.length) {
      if (idx < a.length) {
        if (Math.random() < 0.1) {
          ans = new Array(ans.length)
            .fill(null)
            .map((_) => getRandomLetter())
            .join("");
        } else {
          ans =
            new Array(idx + 1)
              .fill(null)
              .map((_) => getRandomLetter())
              .join("") + a.slice(idx + 1, a.length);
          idx++;
        }
      } else {
        if (timer % 2) {
          // remove the character
          ans =
            new Array(ans.length - 1)
              .fill(null)
              .map((_) => getRandomLetter())
              .join("") + a.slice(idx + 1, a.length);
        } else {
          // swap that character
          ans =
            new Array(ans.length)
              .fill(null)
              .map((_) => getRandomLetter())
              .join("") + a.slice(idx + 1, a.length);
        }
      }
    } else if (a.length < b.length) {
      if (idx < a.length) {
        if (Math.random() < 0.1) {
          ans = new Array(ans.length)
            .fill(null)
            .map((_) => getRandomLetter())
            .join("");
        } else {
          ans =
            new Array(idx + 1)
              .fill(null)
              .map((_) => getRandomLetter())
              .join("") + a.slice(idx + 1, a.length);
          idx++;
        }
      } else {
        if (timer % 2) {
          // add the character
          ans =
            new Array(ans.length + 1)
              .fill(null)
              .map((_) => getRandomLetter())
              .join("") + a.slice(idx + 1, a.length);
        } else {
          // swap that character
          ans =
            new Array(ans.length)
              .fill(null)
              .map((_) => getRandomLetter())
              .join("") + a.slice(idx + 1, a.length);
        }
      }
    } else if (a.length === b.length) {
      if (timer < 30) {
        ans = new Array(ans.length)
          .fill(null)
          .map((_) => getRandomLetter())
          .join("");
      } else {
        let randoFound = false;
        for (let i = 0; i < a.length; i++) {
          if (!randoFound && a[i] !== b[i]) {
            ans = ans.slice(0, i) + b[i] + ans.slice(i + 1, ans.length);
            randoFound = true;
          } else if (randoFound) {
            ans =
              ans.slice(0, i) +
              getRandomLetter() +
              ans.slice(i + 1, ans.length);
          }
        }
      }
    }
    console.log(ans);
    return [false, ans, idx];
  };
  useEffect(() => {
    const jobTitleArr = [
      "Software Engineer",
      "Rust Engineer",
      "Backend Engineer",
      "Distributed Systems Engineer",
    ];
    let currIdx = 1;
    let outerInterval = null;
    if (jobTitleRef.current && jobTitleRef2.current) {
      const jobTitle = jobTitleRef.current;
      const jobTitle2 = jobTitleRef2.current;
      outerInterval = setInterval(() => {
        jobTitle.style.background = "linear-gradient(40deg, red, orange);";
        let prevWord = jobTitle.innerText;
        const newWord = jobTitleArr[currIdx];
        let idx = 0;
        let timer = 0;
        const interval = setInterval(() => {
          const [sameWord, currNewWord, newIdx] = convertOneWordToNext(
            prevWord,
            newWord,
            idx,
            timer
          );
          idx = newIdx;
          prevWord = currNewWord;
          timer++;
          jobTitle.innerText = prevWord;
          jobTitle2.innerText = prevWord;
          if (sameWord) {
            currIdx = (currIdx + 1) % jobTitleArr.length;
            clearInterval(interval);
          }
        }, 50);
      }, 5000);
    }
    return () => clearInterval(outerInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobTitleRef.current, jobTitleRef2.current]);
  return (
    <div
      className={`${styles.home}`}
      style={{ backgroundImage: "url(/bg.webp" }}
    >
      {/* <div className="fixed  uppercase text-indigo-500 font-bold py-2 top-0 text-center text-xs z-[2] border-indigo-500 border px-4 w-fit left-[50%] -translate-x-[50%]">
        🚧 &nbsp;Currently Under Active Development&nbsp; 🚧
      </div> */}
      <div className="fixed top-2 right-4 text-sm text-indigo-500 font-bold z-[2] ">
        <ContactModal />
      </div>
      {/* <div className={styles.top_bar_wrapper}>
        <div className={styles.mistake}></div>
        <div className={styles.holiday}></div>
      </div> */}
      <AnimatedBackground />
      <div
        className={`${styles.section01} flex flex-col md:flex-row pointer-events-none flex-nowrap  md:flex-wrap `}
      >
        <div
          className={`${styles.section01_left} min-h-screen pointer-events-none md:pl-4`}
        >
          <div className={`pointer-events-auto ${styles.pfp_image_container}`}>
            <img
              src="pfp.webp"
              className={styles.pro_image}
              height="200"
              width="200"
              alt="pfp"
              decoding="async"
            />
          </div>
          <div className={styles.name_header}>
            <NameSVG />
            <div
              className={`${styles.job_title} flex items-center mb-2 md:mb-6`}
            >
              {"<"}&nbsp;
              <div ref={jobTitleRef} className="inline text-sm md:text-[18px]">
                Software Engineer
              </div>
              &nbsp;
              {">"}
            </div>
            <div
              style={{
                fontSize: "10px",
              }}
              className="text-[14px] md:text-[18px] mx-2 md:mx-0 font-normal text-gray-300"
            >
              <div className=" text-xs md:text-sm font-normal text-gray-300">
                Rust engineer specializing in high-performance backend and
                distributed systems &mdash; async runtimes, consensus, and
                agentic AI infrastructure.
              </div>

              <div className="w-full flex justify-center my-2">
                {/* <div className="w-1/2 max-w-[200px] border border-gray-500/80" /> */}
              </div>
              <div className=" text-xs md:text-sm font-normal text-gray-300">
                <strong>
                  <em>4+</em>
                </strong>{" "}
                years shipping production systems in Rust, Python, and
                TypeScript for clients across Bangladesh, the United States,
                Japan, Australia, Poland, Germany, and Dubai.
              </div>
            </div>
            <div
              className={`${styles.job_title} flex items-center mt-2 md:mt-6`}
            >
              {"</"}&nbsp;
              <div ref={jobTitleRef2} className="inline text-sm md:text-[18px]">
                Software Engineer
              </div>
              &nbsp;
              {">"}
            </div>
          </div>
        </div>

        <div
          className={`min-h-screen max-h-fit ${styles.section01_right_wrapper} flex flex-col`}
        >
          <div className={` flex flex-col ${styles.section01_right}`}>
            <div className={`${styles.about_me} pointer-events-none mb-8 my-2`}>
              TECHNICAL SKILLS
            </div>
            <TechnicalSkills />
            {/* <div className="pointer-events-auto flex-1">
              <div className="flex flex-row items-center text-xs w-full border-b border-[#007bff]  transition-all duration-500">
                {skills.map((skill) => (
                  <div
                    onClick={() => {
                      setSkills((prevSkills) =>
                        prevSkills.map((curr) => ({
                          ...curr,
                          active: curr.id === skill.id,
                        }))
                      );
                    }}
                    style={{
                      background: skill.active
                        ? "linear-gradient(90deg, #007bff, #6610f2)"
                        : "transparent",
                      color: skill.active ? "white" : "",
                    }}
                    className="hover:text-[#007bff]  cursor-pointer flex-1 px-2 py-2 flex items-center justify-center text-[14px]"
                  >
                    {skill.title}
                  </div>
                ))}
              </div>
              <div className="flex flex-col gap-3 transition-all duration-300 min-h-[150px] mt-4">
                {skills
                  .filter((skill) => skill.active)
                  .map((skill) => (
                    <div className=" tracking-wide flex  flex-wrap w-full gap-3">
                      {skill.skillArr.map((subskill) => (
                        <div
                          style={{
                            color: getSkillColor(subskill.rank),
                            border: `1px solid ${getSkillColor(subskill.rank)}`,
                          }}
                          className="group text-xs font-bold uppercase tracking-widest relative border border-[#6610f2]  min-w-[180px] max-w-fit flex-1 text-center min-h-[140px] max-h-[140px] 
                        
                          "
                        >
                          <div
                            className="group-hover:scale-y-0 origin-center transition-all ease-in-out duration-300 delay-100 absolute backdrop-blur-xs bg-black h-2/5 w-full border-y  font-bold top-[50%] left-[50%] -translate-x-[50%] z-[1]  -translate-y-[50%] flex 
                          flex-col items-center justify-center  gap-1 text-[12px] pointer-events-none"
                            style={{
                              border: `1px solid ${getSkillColor(
                                subskill.rank
                              )}`,
                              borderLeft: "none",
                              borderRight: "none",
                            }}
                          >
                            <div className="group-hover:opacity-0 opacity-100 transition-all duration-100 text-[12px]">
                              {subskill.title}
                            </div>
                            <div className="group-hover:opacity-0 opacity-100 transition-all duration-100">
                              <StarSVG
                                rank={subskill.rank}
                                fill={getSkillColor(subskill.rank)}
                              />
                            </div>
                          </div>

                          <img
                            src={subskill.images[0]}
                            className="object-cover object-center h-full w-full opacity-30 blur-[0.5px] hover:blur-0 hover:opacity-100"
                            alt=""
                          />
                        </div>
                      ))}
                    </div>
                  ))}
              </div>
            </div> */}
            <div
              className={`${styles.button_row01} justify-center w-full text-xs pointer-events-auto`}
            >
              <a href="#professional">
                <button className={`cursor-pointer  ${styles.solid_button}`}>
                  PROFESSIONAL
                </button>
              </a>

              <a href="#personal">
                <button className={`cursor-pointer ${styles.outline_button}`}>
                  EXPLORATION
                </button>
              </a>
              <button
                className={`cursor-pointer ${styles.semi_outline_button}`}
              >
                <a
                  href="/resume/resume.pdf"
                  download="AHM-ANNUR-RESUME-2026-07-21.pdf"
                >
                  RESUME
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${styles.section02} pointer-events-none backdrop-blur-[2px]`}
      >
        <div id="timeline" className={styles.professional_projects_wrapper}>
          <div className={`${styles.proproj_line}`}></div>
          <div className={`${styles.professional_projects}`}>EXPERIENCE</div>
        </div>
        <Timeline />
      </div>
      <div className={`${styles.section02} -mt-[32px] pointer-events-none`}>
        <div id="professional" className={styles.professional_projects_wrapper}>
          <div className={`${styles.proproj_line}`}></div>
          <div className={styles.professional_projects}>PROFESSIONAL</div>
        </div>
        <div
          className={`${styles.proproj_card_wrapper} w-full flex flex-wrap items-center justify-center z-[100]`}
        >
          {sampleProjects.map((item) => {
            return <ProjectCard01 key={item.id} product={item} />;
          })}
        </div>
      </div>

      <div className={styles.section02}>
        <div
          id="personal"
          className={`${styles.professional_projects_wrapper}`}
        >
          <div className={styles.proproj_line}></div>
          <div
            className={`${styles.triangular_border} ${styles.professional_projects}`}
          >
            PERSONAL (GITHUB)
          </div>
        </div>
        <div
          className={`${styles.proproj_card_wrapper} w-full flex flex-wrap gap-0 items-center justify-center z-[100]`}
        >
          {samplePersonalProjects.map((item) => {
            return <ProjectCard01 key={item.id} product={item} />;
          })}
        </div>
      </div>
      <div className={styles.footer}>
        Made with&nbsp;💙&nbsp;by{" "}
        <span className={styles.footer_name}>A.H.M ANNUR</span>
      </div>
    </div>
  );
};

const samplePersonalProjects = [
  {
    id: 9,
    title: "Distributed KV Store",
    description:
      "A distributed key-value store with node/client clusters and a centralized registry for cluster membership and discovery.",
    techStack: ["Rust", "Tokio"],
    images: ["projects/error/1_compressed.webp"],
    isVideo: false,
    active: true,
  },
  {
    id: 10,
    title: "P2P File Transfer",
    description:
      "Peer-to-peer file transfer tool with timeout-based peer discovery over UDP and TCP protocols.",
    techStack: ["Rust", "Tokio"],
    images: ["projects/error/1_compressed.webp"],
    isVideo: false,
    active: true,
  },
  {
    id: 1,
    title: "Kafka Android Stream",
    description:
      "Built a real time sensor data streaming pipeline for android to flask backend hosted on nginx server to kafka container and stores on PostgreSQL",
    techStack: ["Docker", "Kafka", "Kotlin", "Flask", "Nginx", "PostgreSQL"],
    images: [
      "projects/kafkastream/1_compressed.webp",
      "projects/kafkastream/2_compressed.webp",
      "projects/kafkastream/3_compressed.webp",
    ],
    isVideo: false,
    active: true,
    hasLink: true,
    link: "https://github.com/Arceen/Kafka-Android-Sensor-Stream",
  },
  {
    id: 7,
    title: "Imstore",
    description:
      "Encodes any file into an image by turning the sequence of 4-bytes into the rgba values. Created a decoder to reverse the process as well",
    techStack: ["Golang"],
    images: [
      "projects/imstore/1_compressed.webp",
      "projects/imstore/2_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 3,
    title: "Go File Manager",
    description:
      "Personal File Manager with tunnel can view any images, video, audio or plain text right from the app. Can execute simple shell commands, browse Files. With combination of tunnels it gives pc access to host from anywhere.",
    techStack: ["Golang", "Htmx", "TailwindCSS", "Gin"],
    images: [
      "projects/fmgo/1_compressed.webp",
      "projects/fmgo/2_compressed.webp",
      "projects/fmgo/3_compressed.webp",
      "projects/fmgo/4_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 2,
    title: "Sand Simulator",
    description:
      "Simulation algorithm for mimicking sand behavior with optimized layer calculation system",
    techStack: ["C++", "SDL2", "CMake"],
    images: ["projects/cpp/1.webm"],
    isVideo: true,
    active: true,
  },

  {
    id: 4,
    title: "Memwars",
    description:
      "Android memory training app with firebase authentication and cloud firestore database. There are a selection of games available.",
    techStack: ["Android", "Firebase", "Kotlin"],
    images: ["projects/memwars/1_compressed.webp"],
    isVideo: false,
    active: true,
  },
  {
    id: 5,
    title: "Abyss",
    description:
      "Dynamic tree categorizer with typescript and raw css. You can take any topic and turn it into an infinite categorizer",
    techStack: ["React.js", "Typescript", "CSS"],
    images: ["projects/abyss/1_compressed.webp"],
    isVideo: false,
    active: true,
  },
  {
    id: 6,
    title: "QikDraw",
    description:
      "Simple Fun Drawing Application using canvas. Pick a color and size and draw away.",
    techStack: ["HTML", "Canvas", "Vanilla JS"],
    images: [
      "projects/qik/1_compressed.webp",
      "projects/qik/2_compressed.webp",
      "projects/qik/3_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },

  {
    id: 8,
    title: "Flavor Fusion",
    description:
      "Contributed to the open source project Flavor Fusion for Hacktoberfest 2023. Had fun implemented the favorite & some core animations of products.",
    techStack: ["Open Source", "Html", "CSS", "Javascript"],
    images: [
      "projects/flavorfusion/1_compressed.webp",
      "projects/flavorfusion/2_compressed.webp",
      "projects/flavorfusion/3_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
];

const sampleProjects = [
  {
    id: 16,
    title: "Graphbit - Enterprise Agentic Framework",
    description: `Key contributor to Graphbit, an open-source Rust agentic AI framework, and its Enterprise Edition. Built the proprietary vector database, MCP/HITL support, and connectors for Atlassian, Microsoft, and Databricks.`,
    techStack: ["Rust", "Tokio", "Vector DB", "MCP"],
    images: ["graphbit.png"],
    isVideo: false,
    active: true,
  },
  {
    id: 17,
    title: "FAST POS System",
    description: `Led backend development of a secure, high-performance analytics platform aggregating multiple distributed POS systems, and a hierarchical multi-level point distribution platform built on AWS Amplify Gen 2.`,
    techStack: ["Rust", "MySQL", "AWS Amplify", "Docker"],
    images: ["fast.png", "fast2.png", "fast3.png"],
    isVideo: false,
    active: true,
  },
  {
    id: 0,
    title: "Point Kikou - Partner System",
    description: `A multi-vendor centralized rewards platform with a unified points system. Contributed core solutions, system design & optimizations and database architecture of the system.`,
    techStack: ["AWS Amplify", "GraphQL", "AWS AppSync", "AWS Lambda", "Cognito", "PostgreSQL", "TypeScript"],
    images: [
      "projects/pk-ps/1_compressed.webp",
      "projects/pk-ps/2_compressed.webp",
      "projects/pk-ps/3_compressed.webp",
      "projects/pk-ps/4_compressed.webp",
      "projects/pk-ps/5_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 1,
    title: "Track My Vehicle",
    description: `Develop & maintain the flagship product of Bondstein Technologies. Brought life like vehicle movement to vehicles. Created custom chart functionalities from scratch for data analysis`,
    techStack: ["Next.js", "Javascript", "PostgreSQL"],
    images: [
      "projects/tmv/1_compressed.webp",
      "projects/tmv/2_compressed.webp",
      "projects/tmv/3_compressed.webp",
      "projects/tmv/4_compressed.webp",
      "projects/tmv/5_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 13,
    title: "Threebie Grocery",
    description:
      "Created an asynchronous data acquisition and storage pipeline in Django, seamlessly integrated with an AI-powered e-commerce platform for a U.S.-based company.",
    techStack: [
      "Django",
      "PostgreSQL",
      "Memcached",
      "AWS",
      "Next.js",
      "TypeScript",
    ],
    images: [
      "projects/threebie/1_compressed.webp",
      "projects/threebie/2_compressed.webp",
      "projects/threebie/3_compressed.webp",
      "projects/threebie/4_compressed.webp",
      "projects/threebie/5_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 4,
    title: "Lexodi",
    description:
      "Collaborated in-house with Singularity Limited on their Polish Advocate and Legal Document Management System, contributing to its design, development, and implementation.",
    techStack: ["Next.js"],
    images: [
      "projects/lexodi/1_compressed.webp",
      "projects/lexodi/2_compressed.webp",
      "projects/lexodi/3_compressed.webp",
      "projects/lexodi/4_compressed.webp",
      "projects/lexodi/5_compressed.webp",
      "projects/lexodi/6_compressed.webp",
      "projects/lexodi/7_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 15,
    title: "BRPFC",
    description:
      "Developed website & panel prestegious racing club of Bangladesh. Created a live auction platform and race results.",
    techStack: ["Django", "Javascript", "jQuery"],
    images: [
      "projects/brpfc/1_compressed.webp",
      "projects/brpfc/2_compressed.webp",
      "projects/brpfc/3_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 2,
    title: "YBX Controller",
    description:
      "Frontend Architect of Bondstein's all-in-one IMS, Technician Management, Operations Management. Contributed to the system design of the core controller",
    techStack: ["Next.js", "Typescript"],
    images: [
      "projects/ybx/1_compressed.webp",
      "projects/ybx/2_compressed.webp",
      "projects/ybx/3_compressed.webp",
      "projects/ybx/4_compressed.webp",
      "projects/ybx/5_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 5,
    title: "KDS",
    description:
      "Innovated a solution to convert real-time coordinates into CAD-printed 2D images, enabling advanced map simulation functionalities. Collaborated closely with Bondstein's ML and R&D teams to develop a comprehensive Port Management System.",
    techStack: ["Nextjs", "SVG", "Canvas"],
    images: [
      "projects/kds/1_compressed.webp",
      "projects/kds/2_compressed.webp",
      "projects/kds/3_compressed.webp",
      "projects/kds/4_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },

  {
    id: 3,
    title: "Payment Module",
    description:
      "Developed Bondstein's central payment system & integrated across all existing software.",
    techStack: ["Nextjs", "Typescript"],
    images: [
      "projects/payment/1_compressed.webp",
      "projects/payment/2_compressed.webp",
      "projects/payment/3_compressed.webp",
      "projects/payment/4_compressed.webp",
      "projects/payment/5_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },

  {
    id: 14,
    title: "My Ace JP",
    description:
      "Developed the large-scale photo editing & image manipulation platforms & admin panel for a Japanese Photo Studio",
    techStack: ["Javascript", "Canvas", "React.js", "Django"],
    images: [
      "projects/myace/1_compressed.webp",
      "projects/myace/2_compressed.webp",
      "projects/myace/3_compressed.webp",
      "projects/myace/4_compressed.webp",
      "projects/myace/5_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 6,
    title: "DMP",
    description:
      "Extended Googla Maps Library for geofence Path & Node based editing for Dhaka Metropoliton Police project",
    techStack: ["Nextjs"],
    images: [
      "projects/dmp/1_compressed.webp",
      "projects/dmp/2_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
  {
    id: 7,
    title: "Robinhood POS",
    description:
      "Developed the POS system for Animal Clinic with offline storage & live video feed capabilities",
    techStack: ["Java", "JavaFX", "Firebase", "iText7"],
    images: [
      "projects/robinhood/1_compressed.webp",
      "projects/robinhood/2_compressed.webp",
    ],
    isVideo: false,
    active: true,
  },
];

// const initSkills = [
//   {
//     id: 1,
//     active: true,
//     title: "Language",
//     color: "#FF0000",
//     skillArr: [
//       {
//         title: "Javascript",
//         rank: 5,
//         images: ["projects/myace/1_compressed.webp"],
//       },
//       {
//         title: "Python",
//         rank: 5,
//         images: ["projects/threebie/1_compressed.webp"],
//       },

//       {
//         title: "C++",
//         rank: 5,
//         images: ["projects/cpp/1.webm"],
//       },
//       {
//         title: "Typescript",
//         rank: 4,
//         images: ["projects/lexodi/1_compressed.webp"],
//       },
//       {
//         title: "Go",
//         rank: 4,
//         images: ["projects/fmgo/1_compressed.webp"],
//       },
//       {
//         title: "Java",
//         rank: 3,
//         images: ["projects/robinhood/1_compressed.webp"],
//       },
//       {
//         title: "Kotlin",
//         rank: 3,
//         images: ["projects/memwars/1.webp"],
//       },
//       {
//         title: "Dart",
//         rank: 3,
//         images: [
//           "projects/brpfc/1_compressed.webp",
//           "projects/brpfc/2_compressed.webp",
//           "projects/brpfc/3_compressed.webp",
//         ],
//       },
//     ],
//   },
//   {
//     id: 2,
//     active: false,
//     title: "Frontend",

//     color: "#00FF00",
//     skillArr: [
//       {
//         title: "Nextjs",
//         rank: 5,
//         images: ["projects/lexodi/2_compressed.webp"],
//       },
//       {
//         title: "Reactjs",
//         rank: 5,
//         images: ["projects/myace/2_compressed.webp"],
//       },
//       {
//         title: "HTML/CSS",
//         rank: 5,
//         images: ["projects/brpfc/2_compressed.webp"],
//       },
//       {
//         title: "Flutter",
//         rank: 4,
//         images: ["projects/error/1_compressed.webp"],
//       },

//       {
//         title: "Vuejs",
//         rank: 3,
//         images: ["projects/error/1_compressed.webp"],
//       },
//       {
//         title: "Angular",
//         rank: 3,
//         images: ["projects/error/1_compressed.webp"],
//       },
//       {
//         title: "JavaFx",
//         rank: 3,
//         images: ["projects/robinhood/2_compressed.webp"],
//       },
//     ],
//   },
//   {
//     id: 3,
//     active: false,
//     title: "Backend",

//     color: "#0000FF",
//     skillArr: [
//       {
//         title: "Django",
//         rank: 5,
//         images: ["projects/threebie/4_compressed.webp"],
//       },
//       {
//         title: "Nodejs",
//         rank: 5,
//         images: ["projects/error/1_compressed.webp"],
//       },
//       {
//         title: "Expressjs",
//         rank: 5,
//         images: ["projects/error/1_compressed.webp"],
//       },
//       {
//         title: "Nestjs",
//         rank: 4,
//         images: ["projects/error/1_compressed.webp"],
//       },
//       {
//         title: "Flask",
//         rank: 4,
//         images: ["projects/kafkastream/1_compressed.webp"],
//       },

//       {
//         title: "Gin",
//         rank: 3,
//         images: ["projects/fmgo/2_compressed.webp"],
//       },
//       {
//         title: "FastAPI",
//         rank: 3,
//         images: ["projects/error/1_compressed.webp"],
//       },
//     ],
//   },
//   {
//     id: 4,
//     active: false,
//     title: "Database",

//     color: "#FA00FF",
//     skillArr: [
//       {
//         title: "PostgreSQL",
//         rank: 5,
//         images: ["projects/threebie/5_compressed.webp"],
//       },
//       {
//         title: "MySQL",
//         rank: 5,
//         images: ["projects/brpfc/3_compressed.webp"],
//       },
//       {
//         title: "MongoDB",
//         rank: 4,
//         images: ["projects/kafkastream/3_compressed.webp"],
//       },
//       {
//         title: "Firebase",
//         rank: 4,
//         images: ["projects/memwars/1.webp"],
//       },

//       {
//         title: "Redis",
//         rank: 4,
//         images: ["projects/kafkastream/2_compressed.webp"],
//       },
//       {
//         title: "Neo4j",
//         rank: 4,
//         images: ["projects/errors/1_compressed.webp"],
//       },
//     ],
//   },
//   {
//     id: 5,
//     active: false,
//     title: "DevOps",

//     color: "#00FAFF",
//     skillArr: [
//       {
//         title: "Linux",
//         rank: 5,
//         images: ["projects/myace/4_compressed.webp"],
//       },
//       {
//         title: "Docker",
//         rank: 5,
//         images: ["projects/kafkastream/1_compressed.webp"],
//       },
//       {
//         title: "Jenkins",
//         rank: 5,
//         images: ["projects/error/1_compressed.webp"],
//       },
//       {
//         title: "Kubernetes",
//         rank: 4,
//         images: ["projects/error/1_compressed.webp"],
//       },
//       {
//         title: "Nginx",
//         rank: 5,
//         images: ["projects/brpfc/3_compressed.webp"],
//       },
//       {
//         title: "AWS",
//         rank: 4,
//         images: ["projects/threebie/1_compressed.webp"],
//       },
//       {
//         title: "Kafka",
//         rank: 4,
//         images: ["projects/kafkastream/3_compressed.webp"],
//       },
//     ],
//   },
// ];
export default Home;
